// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, WithClass, WithTagName } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

export class EmailViewer extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.addEventListeners();
    this.setInlineSources();
    this.resizeIframe();
  }

  setInlineSources() {
    if ((this.document != null) & (this.attachments != null)) {
      const tags = this.document.getElementsByTagName("img");

      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        const split = tag.src.split(":");

        if ((split.length == 2) && (split[0] == "cid"))
          tag.src = this.attachments.dataset.Uri + split[1];
      }
    }
  }

  resizeIframe() {
    if (this.iframe != null) {
      this.iframe.style.height = null;
      this.iframe.style.height = this.document.body.scrollHeight + "px";
    }
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.iframe = query.getChild(WithTagName("IFRAME"));
    this.attachments = query.getChild(WithClass("Attachments"));

    if (this.iframe != null)
      this.document = this.iframe.contentWindow.document;
  }

  addEventListeners() {
    if (this.iframe != null)
      window.addEventListener("resize", () => { this.resizeIframe(); }, false);
  }
}

interactivityRegistration.register("EmailViewer", function (element) { return new EmailViewer(element); });
